import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';

export default {
    methods: {
        GetBabyParentList() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                BabyId: this.BabyId,
            };

            this.loading = true;
            this.lists = []
            $http.get("api/Baby/GetBabyParentList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.lists = Data;
                });
            });
        },


    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/LBHomeOrder/components/parentList/services.js